import WorkoutTypes from '@/pages/WorkoutTypes';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

export default function WorkoutTypesPage() {
  return (
    <ProtectedRoute>
      <WorkoutTypes />
    </ProtectedRoute>
  );
}
